// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/e4f609df5a48ea49da85.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"000d6189418a7018052e","216":"25deaccf8a34e9e84f64","217":"81df15cae58faced205c"}[chunkId] + ".chunk.js";
};